import captionService from 'CaptionService';

export const menu = {
	more: () => captionService.getString('cb8b9690-969a-44d0-9cec-0b4083d3dde1', 'More')
};
